import React from "react";

import {
  Card,
  Divider,
  Section,
  Typography,
} from "@samskip/frontend-components";
import { useTranslation } from "react-i18next";

import { CalculatePriceTranslation } from "../../constants";
import { PriceResult } from "../../types";

interface PriceResultSectionProps {
  result: PriceResult;
}

const PRICE_NOT_FOUND = -1;

const PriceResultSection = ({ result }: PriceResultSectionProps) => {
  const { t } = useTranslation();

  if (result.Amount === PRICE_NOT_FOUND) {
    return (
      <Section title={t(CalculatePriceTranslation.RESULTS)}>
        <Typography>{t(CalculatePriceTranslation.PRICE_NOT_FOUND)}</Typography>
      </Section>
    );
  }

  const formattedPrice = new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(result.Amount);

  return (
    <Card>
      <Typography fontWeight="bold" textCase="upper" variant="body-xs">
        {t(CalculatePriceTranslation.PRICE_INC_VAT)}
      </Typography>
      <Typography fontWeight="bold" variant="h4">
        {`${formattedPrice} kr`}
      </Typography>
      <Divider />
      <Typography color="neutral-500" variant="body-xs">
        {`* ${t(CalculatePriceTranslation.PRICE_DISCLAIMER)}`}
      </Typography>
    </Card>
  );
};

export default PriceResultSection;
